
import { FlatTourData } from './tourTransformUtils';
import { TourDetailExhibit } from '@/hooks/useTourDetail';

export function transformTourDataForDetail(tourData: any, language: string): FlatTourData | null {
  if (!tourData) return null;

  // Find the appropriate translation
  const translations = tourData.tour_translations || [];
  const currentTranslation = translations.find((t: any) => t.language_code === language);
  const englishTranslation = translations.find((t: any) => t.language_code === 'en');
  const fallbackTranslation = translations[0];
  
  const activeTranslation = currentTranslation || englishTranslation || fallbackTranslation;

  return {
    id: tourData.id,
    title: activeTranslation?.title || tourData.name || 'Untitled Tour',
    description: activeTranslation?.description || '',
    cover_image: tourData.cover_image || '',
    duration: tourData.duration || 0,
    tour_type: tourData.tour_type || 'indoor',
    status: tourData.status || 'draft',
    tags: tourData.tags || [],
    exhibits: [],
    exhibitCount: 0,
    // Include map data - FIXED
    mapType: tourData.maptype || 'indoor',
    mapImage: tourData.mapimage || null
  };
}

export function transformTourExhibitsData(exhibitsData: any[], language: string): TourDetailExhibit[] {
  if (!Array.isArray(exhibitsData)) return [];

  return exhibitsData
    .filter(item => item?.exhibit?.id && item?.exhibit?.status === 'published')
    .map(item => {
      const exhibit = item.exhibit;
      const translations = exhibit.exhibit_translations || [];
      
      // Find appropriate translations
      const currentTranslation = translations.find((t: any) => t.language_code === language);
      const englishTranslation = translations.find((t: any) => t.language_code === 'en');
      const fallbackTranslation = translations[0];
      
      const activeTranslation = currentTranslation || englishTranslation || fallbackTranslation;
      
      // Get image from media - improved logic
      const media = exhibit.media || [];
      const imageMedia = media.find((m: any) => m.type === 'image');
      
      // Try multiple ways to get the image URL
      let image = '/placeholder.svg';
      if (imageMedia) {
        if (imageMedia.media_file?.url) {
          image = imageMedia.media_file.url;
        } else if (imageMedia.media_id?.url) {
          image = imageMedia.media_id.url;
        }
      }
      
      // Extract location from metadata if available
      let location = null;
      if (imageMedia?.media_file?.metadata?.location) {
        const locationData = imageMedia.media_file.metadata.location;
        if (locationData.floor && locationData.room) {
          location = {
            floor: locationData.floor,
            room: locationData.room
          };
        }
      }

      return {
        id: exhibit.id,
        numberCode: exhibit.number_code || '',
        titleEn: englishTranslation?.title || exhibit.number_code || 'Unknown',
        titleHe: translations.find((t: any) => t.language_code === 'he')?.title || exhibit.number_code || 'Unknown',
        image: image,
        location: location
      };
    });
}
